export type ThemeLayout = {
	/**
	 * Minimum size for a pointer input target
	 * https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
	 */
	targetSize: string,
	navBarHeight: string;
	contentWidth: string;
	contentMaxWidth: string;
	contentNarrowMaxWidth: string;
	contentWideMaxWith: string;
};

export const NAV_BAR_HEIGHT = 44;
export const CONTENT_MAX_WIDTH = 1164;
export const layout: ThemeLayout = {
	targetSize: "44px",
	navBarHeight: NAV_BAR_HEIGHT + "px",
	contentWidth: "95vw",
	contentMaxWidth: CONTENT_MAX_WIDTH + "px",
	contentNarrowMaxWidth: "70ch",
	contentWideMaxWith: (CONTENT_MAX_WIDTH * 1.5) + "px",
};


declare module "@mui/material/styles" {
	interface Theme {
		layout: ThemeLayout;
	}
	interface ThemeOptions {
		layout: ThemeLayout;
	}
}
